import 'alpinejs';
// import './slider';
import './logo_slider';

document.documentElement.className += (window.self == window.top ? "" : "framed");

// const menu = document.querySelector('#main-menu');
// const menuToggle = document.querySelector('#menu-toggle');

// menuToggle.addEventListener('click', (e) => {
//   e.preventDefault();

//   if (window.getComputedStyle(menu).display === 'block') {
//     menu.style.display = 'none';
//   } else  {
//     menu.style.display = 'block';
//   }
// });